module.exports = __webpack_public_path__ + "media/images/payments/payza-dark-d3650ff582a4b94d7247bc9e2e93182c.svg";